export default __webpack_public_path__ + "static/media/eye.800daea4.svg";